import ApiService from './';

/**
 * @heading1: Activity API service.
 * @paragraph: This module provides a set of methods to interact with the activity API.
 * It handles operations like Fetching activities etc.
 */

const ChartApi = {
    /**
     * @heading3: Fetch deal actvities
     * @paragraph: Sends a POST request to retrieve all deal activities available for the user.
     * @param: {string} token - The user's authentication token.
     * @param: {number} deal_id - The parameters required deal_id on which the deal's activity will be fetch.
     * @returns: {Promise<unknown[]>} - The response containing a list of all deal actvities.
     * @separator:
     */
    fetchAnalyticsDataForSales: (token: string, time: 'All time' | 'Last 6 months' | 'Last 3 months' | 'Last month' | 'Last week') => {
        // Perform a POST request to fetch deal activities with the deal id
        return ApiService.apiHit({
            url: 'get-analytics-agency',
            method: 'post',
            token,
            data: { time },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchAnalyticsDataForCustomer: (token: string, time: 'All time' | 'Last 6 months' | 'Last 3 months' | 'Last month' | 'Last week') => {
        // Perform a POST request to fetch deal activities with the deal id
        return ApiService.apiHit({
            url: 'get-analytics-client',
            method: 'post',
            token,
            data: { time },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchDealsBreakDownForSales: (token: string, time: 'All time' | 'Last 6 months' | 'Last 3 months' | 'Last month' | 'Last week') => {
        // Perform a POST request to fetch deal activities with the deal id
        return ApiService.apiHit({
            url: 'deals-breakdown-agency',
            method: 'post',
            token,
            data: { time },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    /**
     * @heading3: Fetch all actvities
     * @paragraph: Sends a POST request to retrieve all activities available for the user.
     * @param: {string} token - The user's authentication token.
     * @returns: {Promise<unknown[]>} - The response containing a list of all actvities.
     * @separator:
     */
    fetchActivities: (token: string) => {
        // Perform a Get request to fetch all activities
        return ApiService.apiHit({
            url: 'activity-log',
            method: 'get',
            token
        });
    },
    fetchAgencysClientAnalytics: (token: string) => {
        // Perform a POST request to fetch deal activities with the deal id
        return ApiService.apiHit({
            url: 'get-company-analytics',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default ChartApi;
